/** نام موتور جلسه نباید در هیچ متن قابل‌مشاهدهٔ پنل بیاید. */

const LONG_NAME_RE = /big\s*blue\s*button|بیگ[\s\u200c-]*بلو[\s\u200c-]*باتن/gi;
const TOKEN_RE = /(^|[^\p{L}\p{N}_])bbb(?=$|[^\p{L}\p{N}_])/giu;
const VENDOR_LABEL_RE = /^(?:bbb|big\s*blue\s*button|بیگ[\s\u200c-]*بلو[\s\u200c-]*باتن|ضبط\s*(?:bbb|آنلاین|big\s*blue\s*button))$/i;
const PRESERVE_KEY_RE = /(?:^id$|_id$|url$|uri$|path$|slug$|token$|hash$)/i;

export function hideConferenceVendorName(text) {
  if (typeof text !== 'string' || text === '') return text;
  const replaced = text
    .replace(LONG_NAME_RE, 'جلسه آنلاین')
    .replace(TOKEN_RE, '$1آنلاین')
    .replace(/(?:جلسه آنلاین)(?:\s+جلسه آنلاین)+/g, 'جلسه آنلاین')
    .replace(/[ \t]{2,}/g, ' ');
  return replaced;
}

export function isConferenceVendorLabel(text) {
  return VENDOR_LABEL_RE.test(String(text || '').trim());
}

export function publicSourceLabel(label, source) {
  const raw = String(label || '').trim();
  if (!raw || isConferenceVendorLabel(raw)) {
    if (source === 'manual_upload') return 'آپلود دستی';
    if (source === 'browser_recording') return 'ضبط زنده';
    if (source === 'local') return 'محلی';
    return 'ضبط آنلاین';
  }
  return hideConferenceVendorName(raw) || 'ضبط آنلاین';
}

export function publicMeetingLocation(location, fallback = 'جلسه آنلاین') {
  const raw = String(location || '').trim();
  const safeFallback = String(fallback || '').trim() || 'جلسه آنلاین';
  if (!raw || isConferenceVendorLabel(raw)) return safeFallback;
  const scrubbed = hideConferenceVendorName(raw).trim();
  if (!scrubbed || scrubbed === 'آنلاین' || isConferenceVendorLabel(scrubbed)) return safeFallback;
  return scrubbed;
}

export function scrubDisplayedCopy(value, parentKey = '') {
  if (typeof value === 'string') {
    if (PRESERVE_KEY_RE.test(parentKey) || /^https?:\/\//i.test(value.trim())) return value;
    return hideConferenceVendorName(value);
  }
  if (Array.isArray(value)) return value.map((item) => scrubDisplayedCopy(item));
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, scrubDisplayedCopy(item, key)]),
    );
  }
  return value;
}
